import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { Inject } from '@angular/core';
import { Associate } from '@quorum/models/xs-resource';

@Component({
  selector: 'quorum-gm-my-rewards-verify-account-dialog',
  templateUrl: './gm-my-rewards-verify-account-dialog.component.html',
  styleUrls: ['./gm-my-rewards-verify-account-dialog.component.scss'],
})
export class GmMyRewardsVerifyAccountDialogComponent {
  customerInformationForm = this.fb.group({
    firstName: [this.dialogData.associate.firstName, [Validators.pattern("^[a-zA-Z \\-']+")]],
    email: [
      this.dialogData.associate.emailAddress,
      [Validators.required, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$')],
    ],
  });

  constructor(
    public dialogRef: MatDialogRef<GmMyRewardsVerifyAccountDialogComponent>,
    public fb: FormBuilder,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public dialogData: { associate: Associate; mode: string; memberStatus?: string }
  ) {}

  verifyOrRegister() {
    this.dialogRef.close({
      firstName: this.customerInformationForm.get('firstName')?.value,
      emailAddress: this.customerInformationForm.get('email')?.value,
    });
  }

  cancel() {
    this.dialogRef.close();
  }
}
